import React from "react";

/**
 * Animated equalizer bars used inline next to the title when audio is playing.
 */
export default function EqIndicator({ playing, className = "" }) {
  return (
    <div
      className={`inline-flex items-end gap-[2px] h-3 ${className}`}
      aria-hidden
      data-testid="eq-indicator"
    >
      {[0, 1, 2, 3].map((i) => (
        <span
          key={i}
          className="block w-[2px] bg-[#FF3B30] origin-bottom"
          style={{
            height: "100%",
            animation: playing
              ? `eq-bounce 0.9s ease-in-out ${i * 0.12}s infinite`
              : "none",
            opacity: playing ? 1 : 0.35,
            transform: playing ? undefined : "scaleY(0.3)",
            transition: "transform 200ms ease",
          }}
        />
      ))}
      <style>{`
        @keyframes eq-bounce {
          0%, 100% { transform: scaleY(0.25); }
          25% { transform: scaleY(0.95); }
          50% { transform: scaleY(0.55); }
          75% { transform: scaleY(0.8); }
        }
      `}</style>
    </div>
  );
}
